/**
 * NOTE: This file is part of the legacy Notes feature.
 * User-facing text has been renamed to "Documentation" for clarity.
 * For the new Notes feature, check the Hub implementation.
 */

import { DEFAULT_TIMEZONE } from "@/lib/constants";
import { DatePickerWithPresets } from "@/components/ui/date-picker-with-presets.tsx";
import { Label } from "@/components/ui/label.tsx";
import { TimePicker } from "@/components/ui/time-picker.tsx";
import { TimezoneSelect } from "@/components/ui/timezone-select.tsx";
import { TimeValue } from "react-aria";
import { Time } from "@internationalized/date";

interface NoteReminderFormProps {
  setValue: (key: string, value: Date | TimeValue | string | undefined) => void;
  date: Date | undefined;
  time: TimeValue | undefined;
  timezone: string | undefined;

  maxDate?: Date;
  disabledDates?: Date[];
  showPresets?: boolean;
}

export function NoteReminderForm({
  date,
  time,
  timezone,
  setValue,
  showPresets = true,
  disabledDates = [],
  maxDate,
}: NoteReminderFormProps) {
  return (
    <div className="mt-2 flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <Label className="text-sm font-normal">Date</Label>
        <DatePickerWithPresets
          date={date}
          onDateChange={(value) => {
            setValue("date", value);

            // If time is not set, set it to 00:00
            if (!time) {
              setValue("time", new Time(0, 0) as any);
            }

            if (!timezone) {
              setValue("timezone", DEFAULT_TIMEZONE);
            }
          }}
          className="w-full bg-gray-100"
          showPresets={showPresets}
          disabledDates={disabledDates}
          maxDate={maxDate}
        />
      </div>
      <div className="flex flex-col gap-2">
        <Label className="text-sm font-normal">Time</Label>
        <TimePicker
          value={time}
          onChange={(value) => setValue("time", value || undefined)}
          className="bg-gray-100"
        />
      </div>
      <div className="flex flex-col gap-2">
        <Label className="text-sm font-normal">Timezone</Label>
        <TimezoneSelect
          value={timezone || ""}
          onChange={(value) => setValue("timezone", value)}
          triggerClassName="w-full bg-gray-100"
        />
      </div>
    </div>
  );
}
